import { withTranslation } from 'react-i18next';

import DataTable from '../../../../components/Datatable';
import { getSortKeys, setAdditionalStyles } from '../../../../helpers/table';
import { definitionColumns, definitionRows } from '../keys';

/**
 * Block 01 — the rules the rest of the page is an answer to.
 *
 * It comes first because nothing below means anything without it. Every figure on this report is
 * the consequence of a URL rule somebody wrote, and a reader arriving at a shared link did not
 * write it — so each group, each of its conditions and the filter that condition was sent as are
 * stated before any number is.
 *
 * It shows the *applied* rules, not the ones in the editor. The scope bar is where rules are
 * changed and previewed; this block is what was actually sent, so the two can disagree for as
 * long as an edit is unapplied, and the page never attributes figures to a rule that did not
 * produce them.
 */
function GroupRules({ t, scope }) {
    const columns = definitionColumns(t);
    const rows = definitionRows(t, scope);

    return (
        <div className="card table-main rounded-main overflow-hidden gsc-tool-block">
            <div className="card-header d-flex justify-content-between">
                <div>
                    <p className="card-title">01 · {t('tools.content_groups.definition.title')}</p>
                    <p className="gsc-tool-sub">
                        {t('tools.content_groups.definition.description', {
                            groups: scope.groups.length,
                        })}
                    </p>
                </div>
            </div>

            <div className="card-body">
                <DataTable
                    nodes={rows}
                    COLUMNS={columns}
                    sortFns={getSortKeys(columns)}
                    additionalStyles={setAdditionalStyles(columns)}
                    onlyTable
                    notUseDefaultStyle
                    customContainerStyles="gsc-tool-rules-table"
                />

                <p className="gsc-tool-table-note">
                    {t('tools.content_groups.definition.and_note')}
                </p>
                <p className="gsc-tool-table-note">
                    {t('tools.content_groups.definition.overlap_note')}
                </p>
                <p className="gsc-tool-table-note">
                    {t('tools.content_groups.definition.session_note')}
                </p>
            </div>
        </div>
    );
}

export default withTranslation()(GroupRules);
